import { Select as AntSelect } from "antd";
import { RenderInputProps } from "../types";
import { useFlow } from "../../../FlowEdit/useFlow";
import { useRef } from "react";
import { useRequest } from "ahooks";
import { request } from "../../../../request";
import { ResponseCode } from "../../../../../constants";

type ItemType = {
  title: string;
  value: string;
};

type OptionType = {
  label: string;
  value: string;
};

export default function Select({ item, moduleId }: RenderInputProps) {
  const { updateNodeValue } = useFlow();
  const containerRef = useRef<HTMLDivElement>(null);

  const { data: opts = [] } = useRequest(async () => {
    if (item.request) {
      const rsp = await request<API.BaseResponse<ItemType[]>>(item.request);
      if (rsp.code === ResponseCode.Success) {
        function dfs(list: ItemType[]): OptionType[] {
          return list.map((item) => ({
            label: item.title,
            value: item.value,
          }));
        }
        return dfs(rsp.data || []);
      }
      return [];
    }
    return item.list as OptionType[];
  });

  return (
    <div ref={containerRef}>
      <AntSelect
        options={opts}
        defaultValue={item.value}
        onChange={(v) => {
          updateNodeValue(moduleId, item.key, v);
        }}
        getPopupContainer={(n) => containerRef.current || n}
        style={{ width: "100%" }}
        placeholder={item.placeholder}
        mode={item.multiple ? "multiple" : undefined}
        showSearch
        optionFilterProp="label"
      />
    </div>
  );
}
